export enum EFilteringState {
  StartDate = "StartDate",
  CreatedAt = "CreatedAt",
}